import { HttpClient } from '@angular/common/http';
import { Injectable, Injector, NgZone } from '@angular/core'
import { Router } from '@angular/router'
import { Observable, from, map } from 'rxjs';
import { AppConfigService } from 'src/app/app-config.service';
import { ResourceService } from './resource.service';
import { User } from 'src/app/models/user';

export interface LoggedInCallback {
  isLoggedIn(message: string, loggedIn: boolean): void
}

@Injectable({
  providedIn: 'root'
})
export class UserAccountService extends ResourceService<User> {

  constructor( private http: HttpClient,
    private configService: AppConfigService, ) {
    super(
      http,
      User,
      'users'
    );
  }


  public getUserData(): Observable<any>  {
    return from(this.api
      .get('route-api', `my`, {}))
      .pipe<any>(map(result => result.resource));
  }


}